/**
 * Given an array of table row data, a field to sort by, a field value, and
 * a direction, returns a new array with the data sorted.
 *
 * @param {array} rows - The array of row data to be sorted.
 * @param {string} activePenalty - The currently displayed penalty type.
 * @param {string|number} field - The field to sort by.
 * @param {string} direction - Either 'ASC' or 'DESC'.
 */
export default function sortRowsByField(rows, activePenalty, field, direction) {
  function getNumericRepresentation(value) {
    // For Readmissions, the values are numbers as strings, "No Penalty" or "*"
    // For HACs, the values are "Y", "N", and "*"
    if ('*' === value) {
      return - 2; // sink to the bottom of the list.
    } else if ('No Penalty' === value || 'N' === value) {
      return - 1;
    } else if ('readmission' === activePenalty) {
      return parseFloat(value);
    }
    return 1;
  }

  const sortMultiplier = 'ASC' === direction ? 1 : - 1;
  // Make a deep copy of the rows array to avoid side effects.
  const newRows = rows.map((row) => ({ ...row }));

  if ('NAME' === field) {
    newRows.sort((itemA, itemB) => itemA.name.localeCompare(
      itemB.name) * sortMultiplier);
  } else if ('number' === typeof field) {
    newRows
      .sort((itemA, itemB) => {
        const objA = itemA.dataPoints.filter((penalty) =>
        activePenalty === penalty.type && field === penalty.year);
        const objB = itemB.dataPoints.filter((penalty) =>
        activePenalty === penalty.type && field === penalty.year);
        const valueA = objA.length ?
          getNumericRepresentation(objA[0].value) : - 2; // If there is no value for the actively compared penalty, sink it to the very bottom of the sort
        const valueB = objB.length ?
          getNumericRepresentation(objB[0].value) : - 2;
        return (valueA - valueB) * sortMultiplier;
      });
  } else {
    newRows
      .sort((itemA, itemB) =>
        itemA.name.localeCompare(itemB.name)
      ).sort((itemA, itemB) =>
        itemA.state.localeCompare(itemB.state)
      );
  }
  return newRows;
}
